export default () => ({
  hasDeficiency: {
    type: 'radio',
    label: 'Possui alguma deficiência?',
    validation: 'required',
    required: true,
    value: undefined,
    displayBy: 'label',
    trackBy: 'value',
    options: [
      { label: 'Sim', value: true },
      { label: 'Não', value: false }
    ],
    onInput: (_, hasDeficiency, ctx) => {
      if (hasDeficiency) return

      ctx.formData = { hasDeficiency: false }
    }
  },

  disabilityId: {
    type: 'select',
    label: 'Tipo',
    placeholder: 'Selecione o Tipo',
    options: [],
    optionsSrc: 'disabilities',
    displayBy: 'name',
    trackBy: 'id',
    value: '',
    nullable: true,
    isDisabled: formData => !formData?.hasDeficiency
  },

  observations: {
    type: 'text',
    label: 'Observações',
    placeholder: 'Observações',
    textArea: true,
    rows: '2',
    validation: { max: 220 },
    maxLength: 220,
    value: '',
    isDisabled: formData => !formData?.hasDeficiency
  }
})
